import React, { PureComponent } from "react";
import _ from "lodash";
import { Menu, Dropdown, Icon } from "antd";
import { Link } from "react-router-dom";
import { withRedux } from "../hoc";

const mapStateToProps = state => {
  return {
    t: _.get(state, "t"),
    languages: _.get(state, "languages")
  };
};

const actions = {};

@withRedux(mapStateToProps, actions)
export default class MenuBurger extends PureComponent {
  constructor(props) {
    super(props);
    this.menuPanelRef = React.createRef();
  }
  getMenus = () => {
    const { t } = this.props;
    return (
      <Menu>
        <Menu.Item key="0">
          <Link to="/">{t("Home")}</Link>
        </Menu.Item>
        <Menu.Item key="1">
          <Link to="/product">{t("Product")}</Link>
        </Menu.Item>
        <Menu.Item key="2">
          <Link to="/service">{t("Service")}</Link>
        </Menu.Item>
        <Menu.Item key="3">
          <Link to="/tips-trends">{t("Tips & Trends")}</Link>
        </Menu.Item>
        <Menu.Item key="4">
          <Link to="/about">{t("About Us")}</Link>
        </Menu.Item>
        <Menu.Item key="5">
          <Link to="/faq">{t("Faq")}</Link>
        </Menu.Item>
        <Menu.Item key="6">
          <Link to="/contact">{t("Contact Us")}</Link>
        </Menu.Item>
      </Menu>
    );
  };
  render() {
    return (
      <div className="menu-burger">
        <Dropdown
          overlay={this.getMenus()}
          trigger={["click"]}
          getPopupContainer={() => this.menuPanelRef.current}
        >
          <div>
            <Icon type="menu" />
            <div className="menu-panel" ref={this.menuPanelRef} />
          </div>
        </Dropdown>
      </div>
    );
  }
}



// WEBPACK FOOTER //
// ./src/components/MenuBurger.js